<template>
  <!-- 优惠劵列表 -->
  <div class="c-coupon-list">
    <div v-if="couponList&&couponList.length>0">
      <div class="header" @click="select">
        <div class="f28 color-333 f500">不使用优惠券</div>
        <div class="icon">
          <img v-if="curCoupon.id == null" src="@/assets/images/vip/pic_thumb.jpg" alt />
          <img v-else src="@/assets/images/vip/pic.jpg" alt />
        </div>
      </div>
      <div class="c-coupon-item" v-for="(item) in couponList" :key="item.id" @click="select(item)">
        <div class="type flex-dc" v-if="item.couponType==2">
          <span>¥{{item.discountMoney}}</span>
          <span class="f28 color-f5">满{{item.fullMoney}}可用</span>
        </div>
        <div class="type" v-else>
          <div>{{item.shareDescription}}</div>
        </div>
        <div class="info">
          <div class="f30 color-222 f500 single-ellipsis">{{item.name}}</div>
          <!-- 优惠券类型：0:训练营抵扣券 1:私教坊抵扣券 2:满减券 -->
          <div class="f24 color-888 mt10 f500 single-ellipsis">仅限{{item.discountContent}}使用</div>
          <div
            class="f24 color-A mt30 single-ellipsis"
          >有效期至：{{dates.formatDate(new Date(item.endTime), 'yyyy-MM-dd')}}</div>
        </div>
        <div class="icon">
          <img v-if="item.id==curCoupon.id" src="@/assets/images/vip/pic_thumb.jpg" alt />
          <img v-else src="@/assets/images/vip/pic.jpg" alt />
        </div>
      </div>
    </div>
    <gxxt-no-data class="mt200" v-else text="暂无可用优惠券～"></gxxt-no-data>
  </div>
</template>

<script>
import dates from '@/utils/dates'
import { GxxtNoData } from '@/components'
export default {
  components: { GxxtNoData },
  props: {
    couponList: {
      type: Array,
      default: () => [],
    },
    curCoupon: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  emits: ['select'],
  data() {
    return {
      dates,
    }
  },
  methods: {
    select(item) {
      this.$emit('select', item)
    },
  },
}
</script>

<style lang="less" scoped>
.c-coupon-list {
  background: #f7f7f7;
  padding: 30px 32px;
  position: fixed;
  top: 0;
  margin-left: -375px;
  width: 750px;
  left: 50%;
  bottom: 0;
  right: 0;
  z-index: 1000;
  overflow: auto;

  .header {
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
  }

  .icon {
    img {
      width: 35px;
      height: 35px;
    }
  }

  .c-coupon-item {
    height: 220px;
    // background: #FFFFFF;
    margin-top: 30px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: row;
    align-items: center;
    background: url('~@/assets/images/vip/bg-discount.jpg') no-repeat;
    background-size: 100% auto;

    .type {
      width: 224px;
      color: #ff5500;
      font-size: 40px;
      display: flex;
      justify-content: center;

      div {
        width: 120px;
        font-weight: 600;
      }
    }

    .info {
      width: 400px;
      text-align: left;
      padding-left: 26px;
    }
  }
}
</style>
